import { CSSProperties } from 'react';
import { StyleSheet } from 'react-native';
import { MODAL_ZINDEX } from '@shared/styles';
import { MBDimensions } from '@shared/util/dimensions';

export const Styles = StyleSheet.create({
  container: {
    minWidth: 320,
    // TODO(fant): semi-hack to prevent max width from
    // overflowing the modal for smaller screens
    maxWidth: MBDimensions.width > 640 ? 640 : '100vw',
    maxHeight: '95vh',
    borderRadius: 6,
  },
  rightButton: {
    position: 'absolute',
    top: 0,
    right: 0,
    height: 56,
  },
  leftButton: {
    position: 'absolute',
    top: 0,
    left: 0,
    height: 56,
  },
  title: {
    height: 56,
  },
  titleContainer: {
    // Need to set z-index, otherwise the content below the title
    // (eg if it's scrollable) won't be "under" the title's drop
    // shadow (when there is one, aka when backgroundColor is set).
    zIndex: 1,
    height: 56,
  },
  titleWithShadow: {
    backgroundColor: 'white',
    borderTopRightRadius: 6,
    borderTopLeftRadius: 6,
    // TODO(fant): if we use shadows more in shared components, move this to SharedStyles.
    shadowColor: 'black',
    shadowRadius: 10,
    shadowOpacity: 0.2,
  },
  titleText: {
    maxWidth: '100%',
  },
  fromBottomContainer: {
    // align content at bottom
    justifyContent: 'flex-end',
  },
  fromBottomContent: {
    backgroundColor: 'white',
  },
  fromBottomContentBorderRadius: {
    borderRadius: 10,
    overflow: 'hidden',
  },
  popupContent: {
    borderRadius: 6,
    overflow: 'hidden',
  },
});

// react-native-web complains about some styles in here when they're created
// through StyleSheet.create (eg border = string is not ok)
export const UnvalidatedStyles: Record<string, CSSProperties> = {
  webReactModalContent: {
    backgroundColor: 'transparent',
    border: 'none',
    position: 'relative',
    top: undefined,
    left: undefined,
    right: undefined,
    bottom: undefined,
    display: 'flex',
    overflow: 'visible',
    padding: 0,
    maxWidth: '90%',
  },
  webReactModalOverlay: {
    position: 'absolute',
    display: 'flex',
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 0,
    // Make the modal appear over the top nav bar
    // and LayoutContainer overlays on web.
    zIndex: MODAL_ZINDEX,
  },
};
